import _, { get } from 'underscore';

import { Constants } from '@bingads-webui-theme-2018/theme-fluent';

// Global header + Shell status + Shell tab + Add/Remove tile button
const headerHeight = 60 + 56 + 58 + 50;
// Shell nav + Shell scope panel
const sidebarWidth = 64 + 224;
const cardHeight = 389;

export const getResponsiveSize = containerWidth => _.chain(Constants.ResponsiveSizeBreakpoints)
  .filter(({ minWidth }) => containerWidth >= minWidth)
  .last()
  .get('name', 's')
  .value();

export const getResponsiveSizeBasedOnWindowSize = () => getResponsiveSize(window.innerWidth - sidebarWidth);

const getRowSize = () => Math.round((window.innerHeight - headerHeight) / cardHeight);
const getColumnSize = () => {
  const responsiveSize = getResponsiveSizeBasedOnWindowSize();
  if (responsiveSize === 'xxl') {
    return 3;
  } else if (responsiveSize === 'xl') {
    return 2;
  }
  return 1;
};

export const getViewPortCardsCount = (selectedCardsConfig) => {
  const columnSize = getColumnSize();
  const responsiveSize = getResponsiveSizeBasedOnWindowSize();
  const selectedCardSize = selectedCardsConfig.length;

  let remainingRowSize = getRowSize();
  let remainingColumnSize = getColumnSize();
  for (let i = 0; i < selectedCardSize; i += 1) {
    const card = selectedCardsConfig[i];
    let cardSize = 1;
    if (card.size === 'large' && (responsiveSize === 'xxl' || responsiveSize === 'xl')) {
      cardSize = 2;
    }
    if (remainingColumnSize >= cardSize) {
      remainingColumnSize -= cardSize;
    } else {
      remainingRowSize -= 1;
      if (remainingRowSize <= 0) {
        return i;
      }
      remainingColumnSize = columnSize - cardSize;
    }
  }

  return selectedCardSize;
};

export const isInViewPort = (cardIds, id, viewPortSize) => {
  const index = cardIds.indexOf(id);
  return index < viewPortSize && index >= 0;
};
